import {
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AlertDialogData } from 'src/app/types';

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SuccessDialogComponent {
  @Input() data!: AlertDialogData;

  constructor(protected bsModalRef: BsModalRef) {}

  get hasTitle(): boolean {
    return String(this.data.title || '').length > 0;
  }

  get title(): string {
    return this.data.title || '';
  }

  get message(): string {
    return this.data.message;
  }

  get translationParams(): {
    [key: string]: string | number;
  } {
    return this.data.translationParams || {};
  }
}
